function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".prefix__active-users-3{fill:none;stroke-miterlimit:10;stroke-width:3.16px;stroke:#14345d}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "prefix__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "prefix__Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M70 30.82l-2.86-2.26A28 28 0 0046 2.24v-.66A1.58 1.58 0 0044.39 0H34.06a1.58 1.58 0 00-1.58 1.58v.66a28 28 0 00-21.17 26.32l-2.86 2.26a1.56 1.56 0 00-.6 1.23v4.44a1.58 1.58 0 001.58 1.58h7.89v13.34a21.91 21.91 0 0043.81 0V38.07H69a1.58 1.58 0 001.58-1.58v-4.44a1.59 1.59 0 00-.58-1.23zM58 51.41a18.76 18.76 0 01-37.51 0V38.07H58zm9.46-16.5H11v-2.09l2.85-2.25a1.58 1.58 0 00.6-1.24 24.79 24.79 0 0118-23.82V9a1.58 1.58 0 103.16 0V3.15h7.17V9A1.58 1.58 0 0046 9V5.51a24.79 24.79 0 0118 23.82 1.58 1.58 0 00.6 1.24l2.85 2.25z",
  fill: "#f35f20"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.94 81.87H22.49a20.91 20.91 0 00-20.91 20.91v12.55h75.29V107",
  stroke: "#f35f20",
  fill: "none",
  strokeMiterlimit: 10,
  strokeWidth: 3.16
}), /*#__PURE__*/React.createElement("circle", {
  className: "prefix__active-users-3",
  cx: 72.12,
  cy: 81.87,
  r: 16.73
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__active-users-3",
  d: "M63.76 79.78l6.27 6.27L80.49 75.6"
})));

var SvgActiveUsers = function SvgActiveUsers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90.43 116.91",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgActiveUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/active-users.52b963c9.svg";
export { ForwardRef as ReactComponent };